import { useQuery } from '@tanstack/react-query';
import { businessPackageRequest } from '../../business/BusinessPackageRequest';
import { queryKeys } from '../../constants/queryKeys';
import { IdBasedHookOptions } from './types';

function useIsBusinessPackageRequestable({
  id,
  enabled = true,
}: IdBasedHookOptions) {
  const QUERY_KEY = [queryKeys.businessPackageIsRequestable, id];

  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => businessPackageRequest.isBusinessPackageRequestable(id),
    enabled: Boolean(id) && enabled,
  });
}

export default useIsBusinessPackageRequestable;
